export default __webpack_public_path__ + "static/5-3713ca893219ee91ebdf475b785b0500.jpg";